import BaseService from "../../BaseService";

export default class VerordnungMonitoringService extends BaseService {

  constructor() {
    super('monitoring/verordnung');
  }

  async getActiveId() {
    const verordnungen = await this.list()
    const verordnung = verordnungen.find(v => v.status === 'LAUFEND')
      || verordnungen.find(v => v.status === 'ABGESCHLOSSEN')
      || verordnungen[verordnungen.length - 1]
    return verordnung?.id
  }
}
